import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { getDisplayName } from '../helpers/common';

export const withTranslate = WrappedComponent =>
  injectIntl(
    class extends React.Component {
      static displayName = `withTranslate(${getDisplayName(WrappedComponent)})`;

      static propTypes = {
        intl: intlShape.isRequired,
      };

      t = (string, values = undefined) => {
        if (!string) {
          return '';
        }

        return this.props.intl.formatMessage({ id: string }, values);
      };

      render() {
        return <WrappedComponent {...this.props} t={this.t} />;
      }
    },
  );



// WEBPACK FOOTER //
// ./src/shared/hocs/withTranslate.js